import { axios } from '@Root/API'

export const remove = (entryProfileId, id) => {
	return axios.delete(`qualification-award/${entryProfileId}/qualification-subject/${id}`)
}
